module.exports = __webpack_public_path__ + "img/follow.5a8fb8af.png";